import { http } from './request'
import api from './api'
import type { Menu, MenuQueryParams, MenuListResponse } from '@/types/menu'

/**
 * 查询菜单列表
 */
export function queryMenus(params: MenuQueryParams) {
  return http.get<MenuListResponse>(api.menu.list, params)
}

/**
 * 查询菜单树
 */
export function getMenuTree() {
  return http.get<Menu[]>(api.menu.tree)
}

/**
 * 查询用户菜单树
 */
export function getUserMenuTree() {
  return http.get<Menu[]>(api.menu.userMenuTree)
}

/**
 * 查询所有启用的菜单
 */
export function getAllMenus() {
  return http.get<Menu[]>(api.menu.all)
}

/**
 * 根据ID查询菜单
 */
export function getMenuById(menuId: number) {
  return http.get(`${api.menu.getById}/${menuId}`)
}

/**
 * 新增菜单
 */
export function addMenu(data: Partial<Menu>) {
  return http.post(api.menu.add, data)
}

/**
 * 更新菜单
 */
export function updateMenu(data: Partial<Menu>) {
  return http.post(api.menu.update, data)
}

/**
 * 删除菜单
 */
export function deleteMenu(menuId: number) {
  return http.post(api.menu.delete, { menuId })
}

/**
 * 批量删除菜单
 */
export function deleteMenus(menuIds: number[]) {
  return http.post(api.menu.deleteBatch, { menuIds })
}
